import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getPreClaimsFullReleaseListAPI = () => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetFullReg`,
    method: 'get',
  });
};

export type PreClaimsFullReleaseListResponse = {
  key: string; // 'F' or 'R'
  value: string; // 'Full' or 'Release'
}[];

export const fetchPreClaimsFullReleaseList = async (): Promise<PreClaimsFullReleaseListResponse> => {
  const response: AxiosResponse<PreClaimsFullReleaseListResponse> = await getPreClaimsFullReleaseListAPI();
  return response.data;
};
